import {httpAction, getAction, postAction} from '@/api/manage'
//撤回
export function withdraw(applicationCode,that,record){
  if(applicationCode === 'env_audit'){
    epm_withdraw(that,record);
  }else if(applicationCode === 'ipsys'){
    ipsys_withdraw(that,record)
  }else{
    other_withdraw(that,record,applicationCode)
  }
}
function other_withdraw(that,record,applicationCode) {
  let map = {}
  map.applicationCode=applicationCode;
  map.processGuid = record.process_guid;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.approveAction = "Withdraw";
  map.taskCode = record.task_code;
  map.url="/sys/electronic-signed/process/"+record.business_form_no
  map.httptype="Post"
  map.title = that.language['eletronicSigned.withdraw'];
  that.$refs.myTodoCommentsModal.edit(map);
}
function epm_withdraw(that,record) {
  let map = {}
  map.pfBpmProcessId = record.process_guid;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Withdraw";
  map.taskCode = record.task_code;
  map.url="/sys/wfapi/pageToRunProcess"
  map.httptype="Get"
  map.title = that.language['eletronicSigned.withdraw'];
  that.$refs.myTodoCommentsModal.edit(map);
}
function ipsys_withdraw(that,record) {
  if(record.model_code == 'IpsTrademarkUserReport'||record.model_code == 'IpsTrademarkUserReportC') {
    let map = {}
    map.processGuid = record.process_guid;
    map.approverUserCode = that.$store.getters.userInfo.workNo;
    map.approveAction = "Withdraw";
    map.taskCode = record.task_code;
    map.url="/sys/electronicSigned/ipsysProcess/"+record.process_guid
    map.httptype="Post"
    map.title = that.language['eletronicSigned.withdraw'];
    that.$refs.myTodoCommentsModal.edit(map);
  }else{
    other_withdraw(that,record,"ipsys")
  }
}